module.exports = __webpack_public_path__ + "img/Pulverizador axial.19dd1d87.webp";